module.exports = __webpack_public_path__ + "img/Two-Rivers.9bfa719a.jpg";